import { APPLICATIONS, REG_SCOPES } from "@/services/mock";
import type { Constraint, Session, Target } from "@/utils/types/flavor";

// Resolve constraint rows from a session's wizard inputs. Mirrors the
// prototype's `withConstraints` — turns ids (regScope, application) into
// human labels using the mock catalogs.
export function buildSessionConstraints(session: Session): Constraint[] {
  const rows: Constraint[] = [];

  if (session.baseFormula) {
    rows.push({
      key: "base",
      label: "Base formula",
      value: session.baseFormula.name,
    });
  }
  if (session.claim) {
    rows.push({ key: "claim", label: "Claim", value: session.claim });
  }
  if (session.application) {
    const app = APPLICATIONS.find((a) => a.id === session.application);
    if (app) rows.push({ key: "app", label: "Application", value: app.label });
  }
  if (session.form) {
    rows.push({
      key: "form",
      label: "Form",
      value: session.form === "liquid" ? "Liquid" : "Powder",
    });
  }
  if (session.regScope) {
    const scope = REG_SCOPES.find((s) => s.id === session.regScope);
    if (scope)
      rows.push({ key: "reg", label: "Regulatory scope", value: scope.label });
  }
  if (session.inventoryOnly) {
    rows.push({ key: "inv", label: "Mixture scope", value: "Inventory only" });
  }

  if (rows.length === 0) {
    // Demo fallback: give the workbench detail-popover something to show
    // when the user came in without selecting any constraints.
    rows.push(
      {
        key: "base",
        label: "Base formula",
        value: "Strawberry Jam Base",
        family: "fruity",
      },
      { key: "claim", label: "Claim", value: "Clean label" },
      { key: "app", label: "Application", value: "Beverage · Sparkling" },
      { key: "form", label: "Form", value: "Liquid" },
      { key: "reg", label: "Regulatory scope", value: "FDA (US)" },
      { key: "inv", label: "Mixture scope", value: "Inventory only" }
    );
  }

  return rows;
}

export function withSessionConstraints(
  target: Target,
  session: Session
): Target {
  return { ...target, constraints: buildSessionConstraints(session) };
}
